import SectionHeaderBar from './SectionHeaderBar';

export default SectionHeaderBar;
